import _extends from "@babel/runtime/helpers/esm/extends";
// @ts-nocheck

import React from 'react';
function getState(treeNodes, expandedKeys) {
  if (expandedKeys === void 0) {
    expandedKeys = true;
  }
  var entities = [];
  for (var i = 0, len = treeNodes.length; i < len; i++) {
    var node = treeNodes[i];
    convertTreeToEntities(node, i + "", entities, null, expandedKeys);
  }
  var newState = {
    keyEntities: entities,
    treeNodes: treeNodes
  };
  return newState;
}
function convertTreeToEntities(treeNode, key, entities, parentKey, expandedKeys) {
  var children = treeNode.children;
  treeNode['key'] = key;
  var entity = _extends({
    key: key,
    childKey: [],
    parentKey: parentKey
  }, treeNode);
  entities.push(entity);
  if (typeof expandedKeys === 'boolean' && expandedKeys || expandedKeys.length > 0 && expandedKeys.includes(treeNode.id)) {
    mapChildren(children, function (item, index) {
      entity["childKey"].push(key + "-" + index);
      return convertTreeToEntities(item, key + "-" + index, entities, key, expandedKeys);
    });
  } else {
    return null;
  }
}
function mapChildren(children, f) {
  if (Array.isArray(children)) {
    return children.map(function (item, index) {
      return f(item, index);
    });
  } else if (children) {
    return f(children, "0");
  }
  return null;
}
function useItems(items) {
  return React.useMemo(function () {
    if (!items) {
      return items;
    }
    return getState(items);
  }, [items]);
}
export default useItems;